var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.8125L12.5 16.2812C12.3438 16.4375 12.1562 16.5 12 16.5C11.8125 16.5 11.625 16.4375 11.4688 16.3125L6.71875 11.8125C6.40625 11.5312 6.40625 11.0625 6.6875 10.75C6.96875 10.4375 7.4375 10.4375 7.75 10.7188L12 14.7188L16.2188 10.7188C16.5312 10.4375 17 10.4375 17.2812 10.75C17.5625 11.0625 17.5625 11.5312 17.25 11.8125Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/AngleDown.85f2234e7b81ca9d9625f3eba632501d.svg";
export { ForwardRef as ReactComponent };